export function actionSetTypes(value) {
    return {
        type: 'SET_TYPES',
        value: value
    };
}
